import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { fetchMe } from '../api/auth';
import { adminApi } from '../api/admin';

// 認証が通ったあとの最初の画面。
// §13.1: ログイン時通知バナー — オフラインキュー漏れがある場合のみ表示。
export function DashboardPage() {
  const me = useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
  });
  const status = useQuery({
    queryKey: ['offline-queue', 'status'],
    queryFn: adminApi.offlineQueueStatus,
    refetchInterval: 10_000,
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {status.data && status.data.pendingCount > 0 && (
        <Link
          to="/offline-queue"
          style={{
            display: 'block',
            background: '#fef3c7',
            border: '1px solid #fcd34d',
            color: '#92400e',
            padding: '12px 16px',
            borderRadius: 8,
            textDecoration: 'none',
          }}
        >
          :zap: 未処理のオフライン受付が <strong>{status.data.pendingCount}</strong> 件あります。
          クリックして一覧を確認してください。
        </Link>
      )}

      <div className="k-card">
        <h2 style={{ marginTop: 0 }}>Dashboard</h2>
        <p className="k-muted">
          Konecco の管理コンソール。ヘッダから Devices / Projects /
          Request Logs / Offline Queue に移動できます。
        </p>
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
          <StatCard
            title="ユーザ"
            body={
              me.isLoading
                ? '...'
                : me.error
                  ? '取得失敗'
                  : `tenantId=${me.data?.tenantId} sub=${me.data?.sub}`
            }
          />
          <StatCard
            title="OfflineQueue (未処理)"
            body={
              status.isLoading
                ? '...'
                : status.error
                  ? '取得失敗'
                  : String(status.data?.pendingCount ?? 0)
            }
          />
          <StatCard
            title="OfflineQueue (配送済み)"
            body={
              status.isLoading
                ? '...'
                : status.error
                  ? '取得失敗'
                  : String(status.data?.deliveredCount ?? 0)
            }
          />
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, body }: { title: string; body: string }) {
  return (
    <div
      style={{
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        padding: 12,
      }}
    >
      <div className="k-muted" style={{ fontSize: 12 }}>{title}</div>
      <div style={{ fontSize: 18, fontWeight: 600, marginTop: 4 }}>{body}</div>
    </div>
  );
}
